// How a clip's `kind` and `qc` from the engine read on the page. Shared by the
// desktop review card (StoryboardCanvas) and the phone sheet (MobileReviewSheet)
// so both label a clip the same way.
//
// `kind` is one of "artist" | "broll" | "sing" as /status and /clips send it
// (services/corrido-v2/output-verifier.js toClips); "anchor" is the older
// board word for an artist still. Anything unknown reads as b-roll.

export function clipKindLabel(t: (key: string) => string, kind: string | null | undefined): string {
  if (kind === "sing") return t("studio.canvas.sing");
  if (kind === "artist" || kind === "anchor") return t("studio.canvas.artist");
  return t("studio.canvas.broll");
}

/** A clip the quality check flagged: qc present and not ok. A null qc means
 *  the engine did not check it, which counts as clean for "Use all clean". */
export const qcFlagged = (qc: { ok: boolean } | null | undefined): boolean => !!qc && qc.ok === false;

/** Where the engine puts n artist shots on a 36-shot board: k*36/n rounded
 *  half up, the same integer arithmetic as the worker (planner.artist_positions)
 *  and Node (contracts.interleaveArtist). 4 -> 0/9/18/27, 12 -> every third
 *  tile. The placeholder board puts its artist tiles here. */
export function artistPositions(n: number, total = 36): number[] {
  return Array.from({ length: n }, (_, k) => Math.floor((2 * k * total + n) / (2 * n)));
}
